<script>
export default {
    data() {
        return {
            showMenu: false,
            count: "",
        };
	},

    
    async created() {
        const notificationCount = await window.axios.get(`/api/user/notifications_count`);

        this.count = notificationCount.data;

    },
}
</script>

<style lang='stylus' src='./styles/ProfileNavbar.styl' scoped></style>
<template lang='pug' src='./template/ProfileNavbar.pug'></template>
